export const getCurrentQueryObject = (): Record<string, string | null> => {
  const urlParams = new URLSearchParams(window.location.search);
  const currentQuery = Array.from(urlParams.keys()).reduce<Record<string, string | null>>(
    (acc, curr) => {
      acc[curr] = urlParams.get(curr);
      return acc;
    },
    {}
  );

  return currentQuery;
};
